import enList from "@/assets/files/countriesEn";
import ptList from "@/assets/files/countriesPt";
import esList from "@/assets/files/countriesEs";
import { useContextStore } from "@/stores/context";

class CountriesLanguagesHandler {

    constructor() {
        this.countriesList = this.getAllCountries();
    }

    /**
     * Gets translations from file
     * @returns {Object}
     */
    getAllCountries() {
        let list = {};
        for (let lang of ['en', 'pt', 'es']) {
            let targetFile = {};
            switch (lang) {
                case 'en':
                    targetFile = enList;
                    break;
                case 'pt':
                    targetFile = ptList;
                    break;
                case 'es':
                    targetFile = esList;
                    break;
            }

            for (let item of targetFile) {
                if (list[item.code.toLowerCase()] == undefined) {
                    list[item.code.toLowerCase()] = {};
                }

                list[item.code.toLowerCase()][lang] = item[lang];
            }

        }

        return list;
    }

    getAsComboList() {
        const context = useContextStore();
        const lang = context.getLang;

        let list = [];
        for (let code of Object.keys(this.countriesList)) {
            const item = this.countriesList[code];

            list.push({
                code: code.toUpperCase(),
                name: item[lang] ?? item['pt']
            });
        }

        return list;
    }

    /**
     * Tries to translate the sent text
     * Note
     * @param {String} text
     * @param {String} formatOpt 
     * @returns {String}
     */
    translateCountry(countryCode = ''){
        if (!countryCode) {
            return countryCode;
        }
        countryCode = countryCode.toLowerCase();
        
        try {
            const context = useContextStore();
            const lang = context.getLang;

            return this.countriesList[countryCode][lang];
        } catch (error) {
            return countryCode;
        }
    }
}

export default new CountriesLanguagesHandler();